import type { GridRenderEditCellParams } from '@mui/x-data-grid';
import { VayuTextField } from 'apps/app/src/components/design/vayu-theme-components/VayuTextField';

type EditTiersTablePerUnitNumberFieldProps = Pick<GridRenderEditCellParams, 'id' | 'value' | 'api' | 'field'>;

export const EditTiersTablePerUnitCellField: React.FC<EditTiersTablePerUnitNumberFieldProps> = ({ id, value, api, field }) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    await api.setEditCellValue({
      value: event.target.value,
      field,
      id,
    });
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };

  return (
    <VayuTextField
      type="number"
      value={value ?? ''}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onWheel={() => { }}
      autoFocus
    />
  );
};